/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Criterio di spareggio della graduatoria
 */
export enum CriterioSpareggio {

    ISEE_ASC = 'ISEE_ASC',

    PRESENZA_ATTRIBUTO = 'PRESENZA_ATTRIBUTO',

    NUMERO_MINORI = 'NUMERO_MINORI',

    NUMERO_COMPONENTI = 'NUMERO_COMPONENTI',

    ARRIVO = 'ARRIVO'
}

